/**
 * Which node types this Chatwoot + CSML stack can actually run.
 *
 * Two separate things have to hold for a component to work end to end: the
 * CSML engine has to know the function, and
 * Integrations::Csml::ProcessorService has to have a case for the
 * content_type the engine emits for it. Plenty of the palette satisfies
 * neither, so those types are hidden from the palette rather than deleted -
 * their templates, generator branches and importer branches all stay, so a
 * bot that already contains one still loads, renders and round trips, and
 * un-hiding a type once the stack supports it is a one-line change here.
 *
 * See CSML_COMPONENT_SUPPORT.md for the full matrix and how it was
 * measured.
 */

// The engine rejects these outright - `function [X] does not exist` - and
// CSML validates a flow as a whole, so a single one of these nodes makes the
// entire bot fail to save with "Invalid CSML configuration".
export const ENGINE_MISSING_TYPES = [
  'quickreply',
  'radio',
  'multiselect',
  'checkbox',
  'dropdown',
  'calendar',
  'input',
  'latex',
  'signature',
  'userinput',
  'oauth',
];

// These compile and save fine, but the engine emits a content_type that
// ProcessorService#create_messages has no case for, so the message is
// silently dropped and the contact never sees anything.
export const NOT_DELIVERED_TYPES = ['typing', 'url', 'carousel'];

export const UNSUPPORTED_REASON_BY_TYPE = {
  ...Object.fromEntries(ENGINE_MISSING_TYPES.map(t => [t, 'ENGINE_MISSING'])),
  ...Object.fromEntries(NOT_DELIVERED_TYPES.map(t => [t, 'NOT_DELIVERED'])),
};

export function isNodeTypeSupported(type) {
  return !(type in UNSUPPORTED_REASON_BY_TYPE);
}

export function unsupportedReason(type) {
  return UNSUPPORTED_REASON_BY_TYPE[type] || null;
}
